import PropTypes from 'prop-types';
// import Header from '../_common/main/header';
import Header from '../_common/header-simple';
import Footer from '../_common/footer';

// ----------------------------------------------------------------------

export default function SimpleLayout({ children }) {
  return (
    <>
      <Header />

      {children}

      {/* <Footer /> */}
    </>
  );
}

SimpleLayout.propTypes = {
  children: PropTypes.node,
};
